import { render, staticRenderFns } from "./siding-home.vue?vue&type=template&id=70c2a4af&scoped=true&"
import script from "./siding-home.vue?vue&type=script&lang=js&"
export * from "./siding-home.vue?vue&type=script&lang=js&"
import style0 from "./siding-home.vue?vue&type=style&index=0&id=70c2a4af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2a4af",
  null
  
)

export default component.exports